import React, { useEffect } from 'react';
import { Flex, Spinner } from '@chakra-ui/react';
import {
  AuthSpinner,
  Col,
  MediumText,
  useQueryString,
} from '@carafe/components';
import { IoKeyOutline } from 'react-icons/io5';
import { strings } from '@localisation';
import { InvitationAcceptedSignIn } from '@components/invitations';
import { isEVineyardTarget } from '@carafe/models';
import { Centered } from '@layout';

const go = `https://go.vintrace.net`;
const eVineyardUrlBase = process.env.EVINEYARD_URL;

export const AppleCallback = (): JSX.Element => {
  const [invitationAccepted, customerCode, tokenId, target, returnTo] =
    useQueryString([
      'invitationAccepted',
      'customerCode',
      'tokenId',
      'target',
      'returnTo',
    ]);

  useEffect(() => {
    async function handleRedirect(
      customerCode: string | null,
      tokenId: string | null,
    ) {
      if (!customerCode || !tokenId) {
        // send to an error page.
        return;
      }
      await timer(2500);

      let goingTo;

      if (isEVineyardTarget(target)) {
        goingTo = `${eVineyardUrlBase}/car/sso`;
      } else {
        goingTo = `${go}/${customerCode}/sso?`;
      }

      const redirectUrl = new URL(goingTo);
      const params = redirectUrl.searchParams;
      params.append('code', tokenId);
      if (returnTo) {
        params.append('returnTo', returnTo);
      }

      window.location.href = redirectUrl.toString();
    }
    handleRedirect(customerCode, tokenId);
  }, [customerCode, tokenId, target, returnTo]);

  return (
    <>
      {!invitationAccepted && (
        <Centered>
          <Col alignItems="center" maxWidth="21rem">
            <AuthSpinner title={''} description={strings.access.description} />
          </Col>
        </Centered>
      )}
      {invitationAccepted && <Flex
        flexDir="column"
        minHeight="100vh"
        justify="center"
        align="center"
        width="100%"
        px={{ base: '1rem', md: 'unset' }}
        textAlign="center"
      >
        <IoKeyOutline size="1.5rem" />

        <MediumText fontSize="1.75rem" text={strings.access.title} my="0.75rem" />
        <Spinner
          size="xl"
          color="teal.500"
          thickness="2px"
          emptyColor="gray.200"
          speed="0.65s"
        />
        <MediumText
          my="0.75rem"
          color="gray.500"
          text={strings.access.description}
        />
        <InvitationAcceptedSignIn isOpen />}
      </Flex>
      }
    </>
  );
};

async function timer(msec: number) {
  return new Promise((resolve) => setTimeout(resolve, msec));
}
